declare var $: any;

import { IntegerInput } from "./integerInput";

export class HousesComponent {
    static init() {
        IntegerInput.bindEvents();
        $(".js-floors-input input[type=text]").on("updated", HousesComponent.changeApartmentCounts);
    }

    static changeApartmentCounts(e: Event) {
        const $floorInput = $(e.currentTarget);
        const newMultiplier = $floorInput.val();
        const $apartmentInputs = $(".js-apartment-inputs input[type=text]", $floorInput.parents(".js-house-component-inputs"));

        $apartmentInputs.each((index: Number, textBox: any) => {
            const $textBox = $(textBox);
            const $parent = $textBox.parents(".apartment");
            const diff = Number((newMultiplier - $parent.data("multiplier")) * $parent.data("template-count"));

            $textBox.val(Number($textBox.val()) + diff);
            $parent.data("multiplier", newMultiplier);
            $textBox.data("min-value", $textBox.data("min-value") + diff);
            $textBox.data("max-value", $textBox.data("max-value") + diff);
        });
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/components/housesComponent.ts